module.exports = __webpack_public_path__ + "img/social-media-discussion.622d7ea2.svg";